
import { Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

export const ErrorModal = ({ show, onClose, message }) => {
  return (
    <Modal show={show} onClose={onClose} size="md" popup>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-red-500" />
          <h3 className="mb-5 text-lg font-normal text-gray-500">
            {message || "An error occurred. Please try again."}
          </h3>
          <div className="flex justify-center">
            <button
              type="button"
              className="rounded-lg bg-red-500 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-red-600 focus:outline-none"
              onClick={onClose}
            >
              OK
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

